import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { User } from 'APP/store/Users/User/User';

import { IEventCalendar, IUpdateEvent } from '../../Content.types';
import { Form } from '../Form/Form';
import { ICalendarEventSubmitData } from '../Form/Form.types';

interface ICreateProps {
  selectedEvent: IEventCalendar;
  updateSelectedEvent: (params: IUpdateEvent) => void;
  jumpTo: (date: Date) => void;
  onCreate: (params: ICalendarEventSubmitData) => Promise<void>;
  isFormMinimized?: boolean | undefined;
  onClose?: () => void;
  minimizeSideBar?: () => void;
  participantsInfo: User[];
}

export const Create: FC<ICreateProps> = observer((props) => {
  const {
    onCreate,
    selectedEvent,
    updateSelectedEvent,
    jumpTo,
    isFormMinimized,
    onClose,
    minimizeSideBar,
    participantsInfo,
  } = props;

  return (
    <Form
      event={selectedEvent}
      updateEvent={updateSelectedEvent}
      jumpTo={jumpTo}
      handleSubmit={onCreate}
      isFormMinimized={isFormMinimized}
      participantsInfo={participantsInfo}
      onClose={onClose}
      minimizeSideBar={minimizeSideBar}
      isCreate
    />
  );
});
